import(/* webpackMode: "eager" */ "/vercel/path0/app/photovoltaik/page.tsx");
